import React from 'react'
import StyledDiv from './styles'

interface IProps {
  color: string
  id?: string
  text?: string
  textColor?: string
}

export const StopMarker: React.FC<IProps> = ({ color, id, text, textColor }) => {

  return (
    <StyledDiv id={id}>
      { 
        text && 
        (
          <>
            <div className='label' style={{ backgroundColor: color, color: textColor }}>
              { text }
            </div>
            <div className='marker-line' style={{ backgroundColor: color }}></div>
          </>
        )
      }
      <div className='marker-dot' style={{ backgroundColor: color }}>
        <div className='marker-white'></div>
      </div>
    </StyledDiv>
  )
}